import clsx from 'clsx';
// components
import type { IAKBTask } from '@newo/api/gateway';
import DateTime from '@/modules/DateTime/components/DateTime';
// utils
// assets
import styles from '@/pages/AKB/components/Toolbar/components/ImportTextButton/components/Tasks/Tasks.module.css';

interface TasksProps {
    tasks: IAKBTask[];
}

const Tasks = ({ tasks }: TasksProps) => {
    return (
        <div className="flex flex-col-reverse">
            {tasks.map((task) => (
                <div className={styles.task} key={task.id}>
                    <div className="break-all font-semibold">
                        {task.metadata.file_name}
                    </div>
                    <div className={styles.grid}>
                        <div>
                            <div className="text-gray-6">Created at</div>
                            <DateTime value={task.created_at} />
                        </div>
                        <div className="capitalize">
                            <div className="text-gray-6">Status</div>
                            <div
                                className={clsx({
                                    'text-green-6': task.status === 'completed',
                                    'text-red-6':
                                        task.status === 'error' ||
                                        task.status === 'failed',
                                    [styles.yellow]:
                                        task.status === 'pending' ||
                                        task.status === 'processing'
                                })}
                            >
                                {task.status}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Tasks;
